const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSustainabilityPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.4394 22.8324C18.0126 17.1175 23.7582 13.1282 30.421 13.1282C34.9428 13.1282 39.0464 14.9709 42.0209 17.9427C44.4881 20.4099 46.1747 23.6548 46.6765 27.279C46.7323 27.6609 46.7713 28.054 46.7964 28.4498H43.0357L50.8638 37.393L58.6918 28.4498H54.9423C54.92 27.9592 54.8837 27.4713 54.8363 26.9834C53.5512 14.6503 43.0859 4.99902 30.421 4.99902C21.5363 4.99902 13.7389 9.74104 9.43457 16.8276",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.11511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6704 35.6085C43.2506 41.6635 37.3266 45.9539 30.4185 45.9539C21.7373 45.9539 14.6145 39.1824 14.0458 30.6462C14.0235 30.3424 14.0124 30.0329 14.0096 29.7235H17.8093L9.97847 20.7803L2.15039 29.7235H5.87765C5.88044 30.0329 5.88601 30.3424 5.89995 30.6462C6.18152 36.9745 8.87173 42.6894 13.0729 46.8906C17.5166 51.3343 23.6525 54.0887 30.4185 54.0887C37.1872 54.0887 43.3203 51.3343 47.764 46.8906C49.3112 45.3434 50.6522 43.5955 51.7422 41.6858",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.11511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3668 35.7952L26.2533 36.2022C28.9045 37.5376 32.3195 36.8406 34.6278 34.8975C39.1858 31.0616 38.5697 20.8945 38.5697 20.8945C38.5697 20.8945 36.8998 21.756 34.5442 21.7838C31.6449 21.8201 27.703 21.2291 24.5667 23.9165C21.9127 26.1913 21.5364 30.8302 23.4265 33.8103",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.11511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2325 26.623C29.6658 27.8692 27.7116 29.8624 26.4097 32.7394C25.158 35.5021 24.8039 38.0334 25.2639 40.417",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 1.11511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSustainabilityPro);
export default __webpack_public_path__ + "static/media/icon-sustainability-pro.6cea1e6ffabfdcf0640b7a280cb52744.svg";
export { ForwardRef as ReactComponent };